import { ChangeEvent, useEffect, useState } from "react";
import { useEndpoints } from "../../hooks/useEndpoints";
import { useSimpleForm } from "../../hooks/useSimpleForm";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedGym as setSelectedGymAction,
  setUserMe,
} from "../../store/reducers/coachMe";
import { RootState } from "../../store";
import { removeStorageItem, setStorageItem } from "../../utils/localStorage";
import CustomTextInput from "../../shared/CustomInput/CustomTextInput";
import CustomPasswordInput from "../../shared/CustomPasswordInput/CustomPasswordInput";
import CustomButton from "../../shared/CustomButton/CustomButton";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { useToastAlert } from "../../hooks/useToastAlert/useToastAlert";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import LeopartOnDarkvector from "../../assets/icons/LeopartOnDarkvector";
import { isAxiosError } from "axios";
import CustomSelectInput from "../../shared/CustomSelectInput/CustomSelectInput";
import { IAxiosResponses } from "../../typings/AxiosRespnses";
import "./AthleteLogin.scss";
import { useCustomKeycloak } from "../../hooks/useCustomKeycloak";
import { formatFullName } from "../../utils/functions";

export const AthleteLogin = () => {
  const { size, getClassesNameByQuery } = useWindowDimensions();
  const { navigate } = useCustomNavigate();
  const toastAlert = useToastAlert();
  const [isLoadingLogin, setisLoadingLogin] = useState(false);
  const [onBoarding, setOnBoarding] = useState(false);
  const dispatch = useDispatch();
  const { userLogin } = useEndpoints();
  const { keycloak } = useCustomKeycloak();
  const [selectedGym, setSelectedGym] = useState<any>(undefined);
  const [gyms, setGyms] = useState<
    { label: string; value: string }[] | undefined
  >(undefined);
  const me = useSelector((st: RootState) => st.coachMe.userMe);
  const [dataLogin, setDataLogin] = useState<IAxiosResponses["userLogin"]>();
  const { form, handleEventInputChange } = useSimpleForm<
    Parameters<typeof userLogin>[0]
  >({
    email: "leopartlab@gmail.com",
    password: "f",
  });

  useEffect(() => {
    keycloak.authenticated && navigate("GYM_DASHBOARD");
    // eslint-disable-next-line
  }, []);

  const handleLogin = async () => {
    setisLoadingLogin(true);
    try {
      const { data: response } = await userLogin(form);
      // const dataToSave: any = { ...response };
      // console.log("response", response);
      // setStorageItem("userMe", dataToSave);
      // removeStorageItem("coachMe");
      // console.log("response", dataToSave);
      setGyms(
        response.gyms.map((item) => ({
          label: formatFullName(item.idGym.firstName, item.idGym.lastName),
          value: item.idGym._id,
        }))
      );
      // dispatch(setUserMe(dataToSave));
      setDataLogin(response);

      setSelectedGym(response.gyms?.[0].idGym);
    } catch (error) {
      if (isAxiosError(error)) {
      }
      toastAlert({
        duration: 4000,
        type: "error",
        message: "Autenticazione fallita",
      });
    } finally {
      setisLoadingLogin(false);
    }
  };

  const renderFooter = () => {
    return (
      <div className="footer text-medium-14">
        <span
          onClick={() => {
            setOnBoarding((prev) => !prev);
          }}
        >
          © 2024 Leopart. All Rights Reserved.
        </span>
        <div className="container__right">
          <span className="pe-4">Privacy Policy</span>
          <span>Termini e condizioni</span>
        </div>
      </div>
    );
  };
  const renderHeader = () => {
    return (
      <div className="header text-medium-14">
        <div className="d-flex align-items-center">
          <LeopartOnDarkvector w={"44px"} h={"44px"} />
          <span className="title">Leopart</span>
        </div>
        <div>
          <div className="beta__button text-bold-14">
            {size.width >= 576 ? "Entra nella Beta Coach" : "Beta Coach"}
          </div>
        </div>
      </div>
    );
  };

  const onSelectGym = () => {
    if (!selectedGym) return;
    setStorageItem("userMe", dataLogin);
    removeStorageItem("coachMe");
    dispatch(
      setUserMe({
        ...dataLogin!,
        optionsGym: gyms!,
      })
    );
    dispatch(setSelectedGymAction(selectedGym));
    navigate("GYM_DASHBOARD");
  };
  const renderLoginForm = () => {
    return (
      <div id="container-form" className="container__form">
        <h1
          className={`title ${getClassesNameByQuery({
            xs: {
              "text-bold-24": true,
            },
            sm: {
              "text-bold-32": true,
            },
          })}`}
        >
          Accedi
        </h1>
        <span
          className={`description ${getClassesNameByQuery({
            xs: {
              "text-regular-14": true,
            },
            sm: {
              "text-regular-16": true,
            },
          })}`}
        >
          Entra su Leopart e visualizza i tuoi allenamenti.
        </span>
        <CustomTextInput
          label="Email"
          value={form.email}
          className="email__input"
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            handleEventInputChange("email", event)
          }
        />
        <CustomPasswordInput
          label="Password"
          value={form.password}
          className="password__input"
          onChange={(event) => handleEventInputChange("password", event)}
        />
        <p className="forgot__password text-bold-14">Password dimenticata?</p>
        <CustomButton
          fullWidth
          className="submit__button"
          isLoading={isLoadingLogin}
          onClick={handleLogin}
        >
          Avanti
        </CustomButton>
      </div>
    );
  };
  const renderSecondStep = () => {
    return (
      <div id="container-form" className="container__form">
        <h1
          className={`title ${getClassesNameByQuery({
            xs: {
              "text-bold-24": true,
            },
            sm: {
              "text-bold-32": true,
            },
          })}`}
        >
          Accedi
        </h1>
        <span
          className={`description ${getClassesNameByQuery({
            xs: {
              "text-regular-14": true,
            },
            sm: {
              "text-regular-16": true,
            },
          })}`}
        >
          Seleziona la palestra. {selectedGym?._id}
        </span>
        {gyms && (
          <CustomSelectInput
            options={gyms}
            className="mb-4"
            value={selectedGym?._id}
            placeholder="Seleziona..."
            onChange={(value) => {
              setSelectedGym(
                dataLogin?.gyms.find((gym) => gym.idGym._id === value)?.idGym
              );
            }}
          />
        )}

        <CustomButton
          fullWidth
          className="submit__button"
          isLoading={isLoadingLogin}
          onClick={onSelectGym}
        >
          Accedi
        </CustomButton>
      </div>
    );
  };
  const renderStep = () => {
    if (!dataLogin) {
      return renderLoginForm();
    }
    return renderSecondStep();
  };
  return (
    <div className="container__login">
      <div className="container__header">
        {renderHeader()}

        {renderStep()}
      </div>
      <div className="container__footer">{renderFooter()}</div>
    </div>
  );
};

export default AthleteLogin;
